export const DEFAULT_BASE_URL = 'https://exchange.exodus.io/v3';
